

// Modules
import { mapGetters, mapActions } from 'vuex';

// SOPHEOS
import { removeWhitespaces } from '@sopheos/orbjs_rules';

// MIXINS
import errorsMixin from '../mixins/error-handler';

// LIBRARIES
import { getPlaceNameWithPreposition } from '../libraries/utils';

// API
import * as apiReport from '../api/private/report';

export default {
  name: 'SDetailCarousel',
  mixins: [errorsMixin],
  props: {
    detailAdmin: {
      type: String,
      required: true,
    },
    detailPlace: {
      type: String,
      required: true,
    },
    detailStreet: {
      type: String,
      required: true,
    },
    detailId: {
      type: Number,
      required: true,
    },
    detailImages: {
      type: Array,
      default: () => [],
    },
    cityName: {
      type: String,
      default: '',
    },
    openCarouselReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMounted: false,
      // Carousel dialog v-model
      carouselDialog: false,
      carouselLabel: 'Photos de l\'aire de jeux',
      // Carousel index v-model shared between zoomed out & zoomed in
      carouselIndex: 0,
      carouselTransition: 'slide-x-transition',
      currentItemId: 0,
      zoomImageIsMounted: false,
      zoomImageIsZoomed: false,
      // report
      showReportForm: false,
      reportMessage: null,
      reportFormBtn: {
        closeText: 'Annuler',
        confirmText: 'Valider',
      },
      reportFormOptions: { width: '500' },
      reportFormTitle: 'Signalement',
      reportFormLabel: 'Fenêtre de signalement',
      reportFormLoading: false,
      waitReport: false,
    };
  },
  computed: {
    // pour les sizes
    ...mapGetters({
      isXSmall: 'screen/isXSmall',
      isSmall: 'screen/isSmall',
      getHasHover: 'screen/getHasHover',
      isAuth: 'authToken/isAuth',
    }),
    viewNoPic() {
      return this.detailImages.length === 0;
    },
    viewOnePic() {
      return this.detailImages.length === 1;
    },
    viewTwoPics() {
      return this.detailImages.length === 2;
    },
    viewTreePics() {
      return this.detailImages.length > 2;
    },
    previewsImg() {
      return this.detailImages.slice(0, 3);
    },
    reportMessageIsSet() {
      // The message is not null and is not empty
      return this.reportMessage?.length > 0;
    },
    reportMessageIsValid() {
      // The message is set and contains between 10 and 400 characters
      return this.reportMessageIsSet && this.reportMessage.length >= 10 && this.reportMessage.length <= 400;
    },
    processServer() {
      return process.server;
    },
    placeNameWithPreposition() {
      return getPlaceNameWithPreposition(this.cityName);
    },
  },
  watch: {
    openCarouselReport(value) {
      if (value && this.waitReport) {
        this.waitReport = false;
        this.openReport();
      }
    },
    reportMessage() {
      // When the message changes, if it is not set or if it is valid, set the error to false
      if (!this.reportMessageIsSet || this.reportMessageIsValid) {
        this.errors$.handleError(false, 'reports', 'message');
      }
    },
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    ...mapActions({
      initSnackbar: 'snackbar/initSnackbar',
    }),
    // Dialog Box Picture
    dismissPicture() {
      this.carouselIndex = 0;
    },
    closeCarouselForm() {
      this.errors$.reset();
      this.waitReport = false;
      this.reportMessage = null;
      this.showReportForm = false;
    },
    openReport() {
      if (!this.isAuth) {
        this.waitReport = true;
        this.$emit('login');
        return;
      }
      this.showReportForm = true;
    },
    sendReport() {
      this.reportMessage = removeWhitespaces(this.reportMessage);

      // prevalidation
      this.errors$.reset();
      this.errors$.handleError(this.reportMessageIsSet && !this.reportMessageIsValid, 'reports', 'message');
      if (this.errors$.hasErrors()) {
        this.errors$.focusFirstError();
        return;
      }

      const data = {
        context: 'playground',
        playground: this.detailId,
        message: this.reportMessage,
        reason: 4,
        playground_uuid: this.detailImages[this.carouselIndex].uuid,
      };

      this.reportFormLoading = true;
      apiReport.report(data, this).then(() => {
        this.closeCarouselForm();
        const snackbar = {
          options: {
            color: 'success',
          },
          content: 'Votre signalement a été pris en compte',
        };
        this.initSnackbar(snackbar);
      }).catch((error) => {
        // Validation error
        if (error.response && error.response.status === 400) {
          if (this.errors$.hasErrors()) {
            this.errors$.focusFirstError();
            return;
          }
          this.errors$.handleError(true, 'reports', 'form');
        }
      }).finally(() => {
        this.reportFormLoading = false;
      });
    },
    openCarouselDialog(uuid) {
      if (this.viewNoPic) {
        return;
      }
      if (uuid) {
        this.carouselIndex = Math.max(this.detailImages.findIndex((element) => element?.uuid === uuid), 0);
      }
      this.carouselDialog = true;
      this.carouselTransition = null;
      this.carouselTransition = 'slide-x-transition';
    },
    carouselUpdated(event) {
      this.currentItemId = event;
    },
  },
};
